import type { IconComponent } from './icon'

export const Close: IconComponent = ({ className }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <title>Close</title>
            <mask id="path-1-inside-1_3178_402" fill="white">
                <path d="M0 0L8.6225 8.19138C9.39443 8.92471 10.6056 8.92471 11.3775 8.19138L20 0" />
            </mask>
            <path
                d="M1.03312 -1.0875L-0.0543749 -2.12062L-2.12062 0.0543749L-1.03312 1.0875L1.03312 -1.0875ZM21.0331 1.0875L22.1206 0.0543749L20.0544 -2.12062L18.9669 -1.0875L21.0331 1.0875ZM8.6225 8.19138L7.58938 9.27888L8.6225 8.19138ZM-1.03312 1.0875L7.58938 9.27888L9.65563 7.10388L1.03312 -1.0875L-1.03312 1.0875ZM12.4106 9.27888L21.0331 1.0875L18.9669 -1.0875L10.3444 7.10388L12.4106 9.27888ZM7.58938 9.27888C8.94026 10.5622 11.0597 10.5622 12.4106 9.27888L10.3444 7.10388C10.1514 7.28721 9.84861 7.28721 9.65563 7.10388L7.58938 9.27888Z"
                fill="white"
                mask="url(#path-1-inside-1_3178_402)"
            />
            <mask id="path-3-inside-2_3178_402" fill="white">
                <path d="M20 20L11.3775 11.8086C10.6056 11.0753 9.39443 11.0753 8.6225 11.8086L0 20" />
            </mask>
            <path
                d="M18.9669 21.0875L20.0544 22.1206L22.1206 19.9456L21.0331 18.9125L18.9669 21.0875ZM-1.03312 18.9125L-2.12062 19.9456L-0.0543747 22.1206L1.03312 21.0875L-1.03312 18.9125ZM11.3775 11.8086L12.4106 10.7211L11.3775 11.8086ZM21.0331 18.9125L12.4106 10.7211L10.3444 12.8961L18.9669 21.0875L21.0331 18.9125ZM7.58938 10.7211L-1.03312 18.9125L1.03312 21.0875L9.65563 12.8961L7.58938 10.7211ZM12.4106 10.7211C11.0597 9.43779 8.94026 9.43779 7.58938 10.7211L9.65563 12.8961C9.84861 12.7128 10.1514 12.7128 10.3444 12.8961L12.4106 10.7211Z"
                fill="white"
                mask="url(#path-3-inside-2_3178_402)"
            />
        </svg>
    )
}
